import React, { useEffect, useState } from "react";

import ModalNew from "../../../../../components/ui/popup/Modal";
import {
  PopupContent,
  PopupHeader,
  PopupSection,
} from "../../../../../components/ui/popup/common";
import LoadingPlaceholder from "../../../../../components/ui/loading/LoadingPlaceholder";

const GenerateGainLossModal = ({
  isOpen,
  onClose,
  taxYears = [],
  onGenerate,
}) => {
  const [method, setMethod] = useState("FIFO");
  const [selectedYear, setSelectedYear] = useState(taxYears[0] || "");
  const [status, setStatus] = useState(null); // 'loading', 'success', 'error'
  const [message, setMessage] = useState("");

  const handleClose = () => {
    setStatus(null);
    setMessage("");
    onClose();
  };

  const handleConfirm = async () => {
    setStatus("loading");
    const result = await onGenerate(selectedYear, method);

    if (result.success) {
      setStatus("success");
      setMessage(
        result.message || "Gain & Loss report generated successfully!",
      );
    } else {
      setStatus("error");
      setMessage(result.message || "Failed to generate report.");
    }
  };

  useEffect(() => {
    // If we have years and no year is currently selected, pick the first one
    if (taxYears.length > 0 && !selectedYear) {
      setSelectedYear(taxYears[0]);
    }
  }, [taxYears]);

  if (!isOpen) return null;

  return (
    <ModalNew className="content-modal" style={{ maxWidth: "480px" }}>
      <PopupHeader
        title="Generate Gain & Loss"
        setOpenState={handleClose}
        icon={`${process.env.PUBLIC_URL}/images/icons/news_blue_popup.svg`}
        variant="compact"
      />
      <PopupContent>
        {status === "loading" ? (
          <PopupSection>
            <LoadingPlaceholder rows={3} type="line" />
          </PopupSection>
        ) : status === "success" || status === "error" ? (
          <PopupSection style={{ textAlign: "center" }}>
            <p
              className={
                status === "success"
                  ? "popup-success-title"
                  : "popup-error-title"
              }
            >
              {status === "success" ? "✓ Success!" : "✗ Error"}
            </p>
            <p className="popup-description">{message}</p>
            <div
              className="popup-actions"
              style={{ justifyContent: "center", marginTop: "24px" }}
            >
              <button
                type="button"
                className="cta-button primary short"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </PopupSection>
        ) : (
          <PopupSection>
            <p className="popup-description" style={{ marginBottom: "16px" }}>
              The gain and loss report will be generated across all exchanges.
              Please ensure all transactions are submitted first.
            </p>

            <div className="popup-form-group">
              <label className="popup-form-label">Tax Year</label>
              <select
                className="form-input"
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
              >
                {taxYears.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>

            <div className="popup-form-group" style={{ marginTop: "16px" }}>
              <label className="popup-form-label">Cost Basis Method</label>
              <select
                className="form-input"
                value={method}
                onChange={(e) => setMethod(e.target.value)}
              >
                <option value="FIFO">FIFO (First In, First Out)</option>
                <option value="LIFO">LIFO (Last In, First Out)</option>
              </select>
            </div>

            <div className="popup-actions" style={{ marginTop: "24px" }}>
              <button
                type="button"
                className="cta-button secondary short"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                type="button"
                className="cta-button primary short"
                onClick={handleConfirm}
                disabled={!selectedYear}
              >
                Generate
              </button>
            </div>
          </PopupSection>
        )}
      </PopupContent>
    </ModalNew>
  );
};

export default GenerateGainLossModal;
